<!--主办/承办单位管理-->
<template>
  <div class="app_container" :class="{ 'list-drag': dragaable }">
    <search class="search-wrapper" @search="searchHandle" />
    <!--操作栏-->
    <div class="filter_container">
      <butn
        v-permission="'classOrganizer:add'"
        btntype="primary"
        title="新增"
        @click="handleAdd"
        iconName="el-icon-plus"
      ></butn>
      <el-checkbox v-permission="'classOrganizer:drag'" v-model="dragaable" class="drag-box">拖拽排序</el-checkbox>
    </div>
    <el-tree-table
      ref="pageListTable"
      headerRowClassName="RCTableHeader"
      cellClassName="RCTableCell"
      :column-custom-render="columnCustomRender"
      :treeData="feedbackTree"
      :columns="columns"
      :columnSelectionWidth="0"
      :expandAll="true"
    >
    </el-tree-table>
    <!-- 新增、编辑 -->
    <Curd
      v-if="showDialog.flag"
      :showDialog="showDialog"
      :item="curItem" 
      @closeDialog="closeDialog"
    />
  </div>
</template>
<script>
import "@/components/list/table.css";
import butn from "@/components/button/index";
import ElTreeTable from "@panhezeng/el-tree-table";
import Curd from "./curd";
import Sortable from "sortablejs";
import Search from "./search";
import {
  classOrganizerDelete,
  classOrganizerList,
  classOrganizerDrag,
} from "@/api/rescategory";

const test1 = 1;
const test2 = 2;
const TestComp = {
  template: `
      <div>
        <slot/>
      </div>
      `,
};
export default {
  name: "sponsorManage",
  components: { Curd, ElTreeTable, butn, Search },
  data() {
    return {
      feedbackTree: [],
      // expandIndexes: [],
      dragaable: false,
      flatParamList: [],
      curItem: null,
      showDialog: {
        flag: false
      },
      dataname: {},
      columns: [
        {
          label: "类型",
          prop: "organizerTypeName",
          minWidth: "160",
        },
        {
          label: "单位名称",
          prop: "organizerName",
          minWidth: "160",
        },
        {
          label: "标签",
          prop: "organizerTagName",
          minWidth: "150",
        },
        {
          label: "创建时间",
          prop: "createDate",
          minWidth: "150",
        },
        {
          label: "操作",
          prop: "action",
          fixed: "right",
          minWidth: "150",
        },
      ],
      columnCustomRender: {
        action: {
          props: {
            cellData: { invalidData: true },
            test1,
            test2,
            vm: this,
          },
          component: {
            components: { TestComp },
            props: {
              cellData: {
                type: Object,
                default() {
                  return {};
                },
              },
              vm: {
                type: Object,
                default() {
                  return {};
                },
              },
              test2: Number,
            },
            methods: {
              updateHandler() {
                this.vm.curItem = this.cellData.row;
                this.vm.showDialog.flag = true;
              },
              delHandler() {
                this.vm.deleteRes(this.cellData.row);
              },
            },
            template: `
                      <test-comp>
                        <div class="deal-group" v-if="cellData.row.hasChildren !== 1">
                            <el-tooltip
                              effect="dark"
                              placement="top"
                              content="编辑"
                              v-permission="'classOrganizer:update'"
                            >
                              <i class="icon-edit" @click="updateHandler"></i>
                            </el-tooltip>
                            <el-tooltip
                              effect="dark"
                              content="删除"
                              placement="top"
                              v-permission="'classOrganizer:delete'"
                            >
                              <i class="icon-delete" @click="delHandler"></i>
                            </el-tooltip>
                        </div>
                      </test-comp>
                      `,
          },
        },
      },
    };
  },
  watch: {
    dragaable(val) {
      this.rowDrop(val);
    },
  },
  methods: {
    rowDrop(flag) {
      if (!flag) {
        // 关闭拖拽功能时销毁Sortable对象
        this.sort && this.sort.destroy();
      } else {
        const _this = this;
        const tbody = document.querySelector(".el-table__body-wrapper tbody");
        this.sort = Sortable.create(tbody, {
          animation: 180,
          delay: 0,
          sort: true,
          draggable: ".el-table__row",

          onEnd({ oldIndex, newIndex }) {
            let flagDept = true;
            const oldRow = _this.flatParamList[oldIndex];
            const newRow = _this.flatParamList[newIndex];
            if (!oldRow.pid || !newRow.pid) {
              _this.$message({
                message: "顶级节点不能拖拽排序",
                type: "error",
              });
              flagDept = false;
              // // 列表刷新
              _this.$nextTick(() => {
                _this.initData();
              });
              return;
            }
            if (oldRow.pid !== newRow.pid) {
              _this.$message({
                message: "不同分类下不能排序",
                type: "error",
              });
              flagDept = false;
              // // 列表刷新
              _this.$nextTick(() => {
                _this.initData();
              });
            }
            if (flagDept) {
              let offset = newIndex - oldIndex;
              let params = {
                // upOrDown: Number(offset) > 0 ? 1 : -1,
                // dragUuid: oldRow.uuid,
                // otherUuid: newRow.uuid,
                uuid: oldRow.uuid,
                order: oldRow.order,
                targetOrder: newRow.order
              };
              classOrganizerDrag(params).then((res) => {
                if (!res || res.code != 0) return;
                _this.$message({
                  message: "排序成功",
                  type: "success",
                });
                const currR = _this.flatParamList.splice(oldIndex, 1)[0];
                _this.flatParamList.splice(newIndex, 0, currR);
                // _this.expandIndexes = _this.$refs.pageListTable
                //   .getExpandRows()
                //   .map((value) => value.treeFullIndex);
                let feedbackTree = _this.getTree(
                  _this.flatParamList[0].pid,
                  _this.flatParamList
                );
                _this.feedbackTree = JSON.parse(JSON.stringify(feedbackTree));
                _this.flatParamList = [];
                _this.getFlatParamList(_this.feedbackTree);
              });
            }
          },
        });
      }
    },
    // 将普通列表转换为树结构的列表
    getTree(parentId, list) {
      let data = [];
      for (const key in list) {
        if (list[key].pid == parentId) {
          let child = this.getTree(list[key].id, list);
          if (child.length > 0) {
            list[key].children = child;
          }
          data.push(list[key]);
        }
      }
      return data;
    },
    getFlatParamList(data) {
      if (data && data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          this.flatParamList.push(data[i]);
          let curData = data[i].children;
          if (curData && curData.length > 0) {
            this.getFlatParamList(curData);
          }
        }
      }
    },
    handleAdd() {
      this.showDialog.flag = true;
      this.curItem = null;
    },
    //   搜索
    searchHandle(params) {
      this.dataname = params;
      this.initData(this.dataname);
    },
    initData() {
      classOrganizerList(this.dataname).then((res) => {
        this.feedbackTree = this.setLevel(res.data);
        this.flatParamList = [];
        this.getFlatParamList(this.feedbackTree);
      });
    },
    setLevel(arr) {
      if (!Array.isArray(arr)) return;
      let res = arr.map((x) => {
        let n = {
          children: [],
        };
        if (x.children && x.children.length > 0) {
          n.children = x.children.map((t) => {
            return { ...t, canAddChild: true };
          });
        }
        if (n.children.length > 0) {
          return { ...x, children: n.children, canAddChild: true };
        }
        return { ...x, canAddChild: true };
      });
      return res;
    },
    deleteRes(item) {
      let message = "确认删除该单位吗？";
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        classOrganizerDelete({ uuid: item.uuid }).then((res) => {
          if (!res || res.code != 0) return;
          this.initData();
          this.$message.success(res.msg);
        });
      });
    },
    refreshData() {
      // if (this.$refs.pageListTable) {
      //   this.expandIndexes = this.$refs.pageListTable
      //     .getExpandRows()
      //     .map((value) => value.treeFullIndex);
      // }
      this.initData();
    },
    closeDialog(flag) {
      this.showDialog.flag = false;
      this.curItem = null;
      if (flag) {
        this.refreshData();
      }
    }
  },
  created() {
    this.initData();
  }
};
</script>
<style lang="scss" scoped>
/deep/ .drag-box {
  margin-left: 16px;
}
.search-wrapper {
  float: right;
}
</style>
